export const about = {
  seo: {
    title: 'About Us | LensBank Professional Equipment Rental',
    description: 'Over a decade of professional equipment rental experience, trusted by Golden Horse Film Festival and international productions. Taiwan-Japan co-production support, expert team, your ideal creative partner.',
    keywords: 'about LensBank,equipment rental company,Taiwan-Japan collaboration,Golden Horse Film Festival,professional team'
  },
  hero: {
    title: 'About Us',
    subtitle: 'The leading professional equipment rental brand'
  },
  story: {
    title: 'Our Story',
    content: 'LensBank was founded in 2008 with a focus on professional photography and cinematography equipment rental. Over more than a decade, we have accumulated extensive experience and established long-term partnerships with major film events including the Golden Horse Film Festival. Beyond providing equipment, we offer professional technical support and consulting services, becoming the most trusted partner for visual creators.'
  },
  milestones: {
    title: 'Key Milestones',
    items: [
      {
        year: '2008',
        title: 'Founded',
        desc: 'Opened our first store in Taichung and launched professional equipment rental services'
      },
      {
        year: '2010',
        title: 'Multi-location Expansion',
        desc: 'Established locations in Taichung and Tainan, extending services across Taiwan'
      },
      {
        year: '2013',
        title: 'Golden Horse Film Festival Partnership',
        desc: 'Became an official partner of the Golden Horse Film Festival, starting a long-term collaboration'
      },
      {
        year: '2016',
        title: 'Taiwan-Japan Co-production',
        desc: 'Launched cross-border production support services between Taiwan and Japan'
      },
      {
        year: '2023',
        title: 'Urent Service',
        desc: 'Launched the Urent consignment rental service to monetize idle equipment'
      }
    ]
  },
  values: {
    title: 'Our Values',
    items: [
      {
        title: 'Professional Quality',
        desc: 'Rigorous quality control on every piece of equipment to ensure peak performance'
      },
      {
        title: 'Client First',
        desc: 'Expert consultation and technical support to solve your production challenges'
      },
      {
        title: 'Innovation',
        desc: 'Continuously developing new services to meet diverse production needs'
      },
      {
        title: 'Trusted Partner',
        desc: 'Building long-term relationships with clients, growing together'
      }
    ]
  },
  team: {
    title: 'Our Team',
    desc: 'We have a highly experienced professional team including equipment management specialists, technical support staff, and production coordinators. Team members bring extensive film and television production experience, providing the most professional advice and assistance.'
  },
  capabilities: {
    title: 'Our Capabilities',
    items: [
      'Over 1,000+ professional camera and film equipment items',
      '4 service locations (stores + warehouse)',
      'Cross-border Taiwan-Japan production support',
      'Professional technical support team',
      'Crew dispatch and on-set services',
      'Custom production solutions'
    ]
  }
};
